export const SET_ARRANGEMANG = "SET_ARRANGEMANG";
export const FETCH_DELTAGARE = "FETCH_DELTAGARE";
export const CLEAR_ARRANGEMANG = "CLEAR_ARRANGEMANG";
export const ADD_STEP = "ADD_STEP";
export const ADD_STEPS = "ADD_STEPS";
export const RETRIEVED_ERROR = "RETRIEVED_ERROR";
export const FETCH_ARRANGEMANG_PROPERTIES = "FETCH_ARRANGEMANG_PROPERTIES";
export const NEXT_STEP = "NEXT_STEP";
export const CHANGE_STEP = "CHANGE_STEP";
export const PREVIOUS_STEP = "PREVIOUS_STEP";
export const ADD_REQUIRED_FIELDS = "ADD_REQUIRED_FIELDS";
export const ADD_ERRORS = "ADD_ERRORS";
export const SET_OREGELBUNDNA_SAMMANKOMSTER = "SET_OREGELBUNDNA_SAMMANKOMSTER";
export const SET_SCHEMA_KROCKAR = "SET_SCHEMA_KROCKAR";
